"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { LayoutDirective as FlexLayoutLayoutDirective, MediaMonitor, } from '@angular/flex-layout';
var LayoutDirective = (function (_super) {
    __extends(LayoutDirective, _super);
    function LayoutDirective(monitor, elRef, renderer) {
        return _super.call(this, monitor, elRef, renderer) || this;
    }
    Object.defineProperty(LayoutDirective.prototype, "layout", {
        set: function (val) {
            this._cacheInput('layout', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutMobile", {
        set: function (val) {
            this._cacheInput('layoutMobile', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutTablet", {
        set: function (val) {
            this._cacheInput('layoutTablet', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutDesktopSmall", {
        set: function (val) {
            this._cacheInput('layoutDesktopSmall', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutDesktopLarge", {
        set: function (val) {
            this._cacheInput('layoutDesktopLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutDesktopXLarge", {
        set: function (val) {
            this._cacheInput('layoutDesktopXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutDirective.prototype, "layoutDesktopXXLarge", {
        set: function (val) {
            this._cacheInput('layoutDesktopXXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayout'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layout", null);
    __decorate([
        Input('flLayout.mobile'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutMobile", null);
    __decorate([
        Input('flLayout.tablet'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutTablet", null);
    __decorate([
        Input('flLayout.desktop-small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutDesktopSmall", null);
    __decorate([
        Input('flLayout.desktop-large'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutDesktopLarge", null);
    __decorate([
        Input('flLayout.desktop-xlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutDesktopXLarge", null);
    __decorate([
        Input('flLayout.desktop-xxlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutDirective.prototype, "layoutDesktopXXLarge", null);
    LayoutDirective = __decorate([
        Directive({
            selector: "\n    [flLayout],\n    [flLayout.mobile],\n    [flLayout.tablet],\n    [flLayout.desktop-small],\n    [flLayout.desktop-large],\n    [flLayout.desktop-xlarge],\n    [flLayout.desktop-xxlarge],\n  ",
        }),
        __metadata("design:paramtypes", [MediaMonitor, ElementRef, Renderer2])
    ], LayoutDirective);
    return LayoutDirective;
}(FlexLayoutLayoutDirective));
export { LayoutDirective };



// WEBPACK FOOTER //
// layout.directive.js